import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useAdminMemberListStore } from '../../share/store/adminMemberStore';
import SystemAlertInfo from './SystemAlertInfo';
import EmptyList from '../../share/component/EmptyList';
import { SystemAlertData } from '../../../shared/dto/EntityRepository';
import { useAuth } from '../../../shared/hooks/useApi/useAuth';
import { useAuthTokenStore } from '../../../shared/store/authStore';
import { useAdminSystemAlert } from '../../share/hook/useAdminSystemAlert';
import SystemAlertViewer from './SystemAlertViewer';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';
import { PaperBlurFitBtn } from '../../../shared/component/headless/button/BtnBody';
import { SystemAlertType } from '../../../shared/enum/EnumRepository';


const SystemAlertList: React.FC = () => {
  const { user } = useAuth();
  const { authToken } = useAuthTokenStore();
  const { systemAlertList, activeSystemAlert, setActiveSystemAlert, getSystemAlertList } = useAdminSystemAlert();
  const { sortData, pageSize } = useAdminMemberListStore();
  const [selectedId, setSelectedId] = useState<string>("");
  const systemAlertListRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (systemAlertListRef.current) {
      systemAlertListRef.current.focus();
    }
  }, [systemAlertListRef]);

  useEffect(() => {
    const getSystemAlertListWithApi = async () => {
      if (!user) return;
      if (!authToken) return;
      console.log("getting systemAlert list...");
      await getSystemAlertList({ page: 1, size: pageSize, sortData: sortData, filterData: {} });
    }
    getSystemAlertListWithApi();
  }, [user, sortData, authToken]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!systemAlertList.length) return;
    if (e.key === 'ArrowDown') {
      const newIndex = systemAlertList.findIndex(each => each.id === selectedId) + 1;
      if (newIndex < systemAlertList.length) {
        const newId = systemAlertList[newIndex].id;
        changeActiveSystemAlert(newId);
      }
    } else if (e.key === 'ArrowUp') {
      const newIndex = systemAlertList.findIndex(each => each.id === selectedId) - 1;
      if (newIndex >= 0) {
        const newId = systemAlertList[newIndex].id;
        changeActiveSystemAlert(newId);
      }
    }
  };

  const handleClick = (selectedId: string) => {
    changeActiveSystemAlert(selectedId);
  };

  const changeActiveSystemAlert = (newId: string) => {
    const selectedSystemAlert = systemAlertList.find(each => each.id === newId);
    if (selectedSystemAlert) {
      setActiveSystemAlert(selectedSystemAlert);
      setSelectedId(newId);
    }
  };

  const handleCreateSystemAlertViewer = () => {
    setActiveSystemAlert({
      id: "",
      type: SystemAlertType.INFO,
      message: "",
      scheduledStartAt: "",
      scheduledEndAt: "",
      createdAt: "",
      endedAt: "",
    });
  };

  return (
    <SystemAlertListContainer
      tabIndex={0}
      ref={systemAlertListRef}
      onKeyDown={handleKeyDown}>
      <SystemAlertListComp>
        {systemAlertList.map((each: SystemAlertData) =>
          <SystemAlertInfo
            key={each.id}
            data={each}
            isSelected={each.id === activeSystemAlert?.id}
            handleClick={() => handleClick(each.id)}
          />
        )}
          <BtnContainer>
            <BtnWrapper>
              <HeadlessBtn
                value={"Create"}
                handleClick={handleCreateSystemAlertViewer}
                StyledBtn={PaperBlurFitBtn}
              />
            </BtnWrapper>
            <SpaceBlock />
          </BtnContainer>
        {systemAlertList.length === 0 && <EmptyList message={"system-alerts"} />}
      </SystemAlertListComp>
      <SystemAlertViewer />
    </SystemAlertListContainer>
  );
};


const SystemAlertListContainer = styled.article`
  width: 100%;
  height: calc(80vh - 2vh);
  display: flex;
  outline: none;
`;

const SystemAlertListComp = styled.section`
  flex: 1;
  width: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
`;

const BtnContainer = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const BtnWrapper = styled.div`
  width: 100%;
  display: flex;
  flex: 12;
  justify-content: flex-end;
`;

const SpaceBlock = styled.div`
  flex: 0.5;
  
  display: flex;
  align-items: center;
  justify-content: center;

  border-bottom: 1px solid ${({ theme }) => theme.colors.color_White};
`

export default SystemAlertList;